import React from 'react';
import { useSelector } from 'react-redux';
import { selectAuth, selectUserRoles } from './redux/auth/selectors';
import Loading from './components/UI/loading/Loading';
import AccessDenied from './components/UI/AccessDenied';

const RoleProtectedRoute = ({ children, requiredRoles }: any) => {
  const userRoles = useSelector(selectUserRoles);
  const { isLoggedIn, isLoading } = useSelector(selectAuth);

  if (requiredRoles && requiredRoles.length > 0) {
    // Roles only exist once the sign-in has landed. While it is loading, or the store has just
    // been cleared by a sign-out that is still redirecting, an empty list means "not known
    // yet", not "not allowed", so the 403 must not flash.
    if (isLoading || !isLoggedIn) {
      return <Loading />;
    }
    // Case-insensitive: workspace roles and the platform roles reach the store in different
    // spellings, and a route's list should not have to know which.
    const held = new Set(userRoles.map((role: any) => String(role).toUpperCase()));
    const hasRequiredRole = requiredRoles.some((role: any) => held.has(String(role).toUpperCase()));
    if (!hasRequiredRole) {
      return <AccessDenied />;
    }
  }

  return <>{children}</>;
};

export default RoleProtectedRoute;
